import { Button, Form, Row } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import FileUploadWithThumbnails from './FileUploadWithThumbnails';
import SignatureUpload from './SignatureUpload';
import { ServerAPI } from '../../common/ServerAPI';
import SignaturePadComponent from './SignaturePadComponent';
import { IMAGE_BASE_URL } from '../../common/Constants';
import SignRemotely from './modals/SignRemotely';

const GuarantorDocumentUpload = ({ documentHolderType, guarantor_index, updateFunction, guarantor_type, isApplicationGuarantor, guarantordata }) => {
    const [guarantorType, setGuarantorType] = useState('');

    useEffect(() => {
        setGuarantorType(guarantor_type);
    }, [guarantor_type])

    return (
        <div className='mx-5'>
            <Form layout="vertical">
                {guarantor_type == 'company' &&
                    <Fragment>
                        <Row gutter={[24, 24]}>
                            <FileUploadWithThumbnails label={"Company ACRA"} maxfile={2} size={6} datakey={documentHolderType} dataApiKey={'company_acra'} guarantor={guarantor_index} updateFunction={updateFunction} />
                            <FileUploadWithThumbnails label={"Profit & Loss (P&L)"} maxfile={2} size={7} datakey={documentHolderType} dataApiKey={'p_l_document'} guarantor={guarantor_index} updateFunction={updateFunction} />
                            <FileUploadWithThumbnails label={"Balance Sheet"} maxfile={2} size={6} datakey={documentHolderType} dataApiKey={'balance_sheet'} guarantor={guarantor_index} updateFunction={updateFunction} />
                        </Row>
                        <Row className='mt-2' gutter={[24, 24]}>
                            <FileUploadWithThumbnails label={"Bank Statement"} maxfile={2} size={6} datakey={documentHolderType} dataApiKey={'bank_statement'} guarantor={guarantor_index} updateFunction={updateFunction} />
                            <FileUploadWithThumbnails label={"Additional Documents"} maxfile={2} size={7} datakey={documentHolderType} dataApiKey={'additional_documents'} guarantor={guarantor_index} updateFunction={updateFunction} />
                        </Row>

                    </Fragment>
                }
                {guarantor_type == 'individual' &&
                    <Fragment>
                        <Row className='' gutter={[24, 24]}>
                            <FileUploadWithThumbnails label={"NRIC (Front & Back)"} maxfile={2} size={6} datakey={documentHolderType} dataApiKey={'nric'} guarantor={guarantor_index} updateFunction={updateFunction} />
                            <FileUploadWithThumbnails label={"NOA (Notice of Assessment, Last 2 years)"} maxfile={2} size={6} datakey={documentHolderType} dataApiKey={'nao'} guarantor={guarantor_index} updateFunction={updateFunction} />
                            <FileUploadWithThumbnails label={"CPF Contribution History (15Months)"} maxfile={2} size={7} datakey={documentHolderType} dataApiKey={'cpf'} guarantor={guarantor_index} updateFunction={updateFunction} />
                        </Row>
                        <div className="text-[15px] font-[700] bg-white mt-[50px] mb-[10px]">
                            Driving License (Front & Back)
                        </div>
                        <Row gutter={[24, 24]}>
                            <FileUploadWithThumbnails label={"License"} maxfile={2} size={6} datakey={documentHolderType} dataApiKey={'driving_license'} guarantor={guarantor_index} updateFunction={updateFunction} />
                            {documentHolderType == 'guarantor_documents' &&
                                <FileUploadWithThumbnails label={"Bank Statement"} maxfile={2} size={6} datakey={documentHolderType} dataApiKey={'bank_statement'} guarantor={guarantor_index} updateFunction={updateFunction} />
                            }
                            <FileUploadWithThumbnails label={"Additional Documents"} maxfile={2} size={7} datakey={documentHolderType} dataApiKey={'additional_documents'} guarantor={guarantor_index} updateFunction={updateFunction} />
                        </Row>
                    </Fragment>
                }
            </Form>

        </div>
    );
};

export default GuarantorDocumentUpload;